import { Meta } from '@master/model/common/Meta'
import { RawKey } from '@master/annotation/RawKey'

export default class PayeeMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  payeeFullname = ''
  payeeNric = ''
  payeeCompanyCode = ''
  payeeEmail = ''
  payeeAddress = ''
  payeeBank = ''
  payeeContact = ''
  payeeDob: number = undefined
  payeePob = ''
  payeeBankName = ''
  payeePostalCode = ''
  payeeCountry = ''
  payeeSwiftCode = ''
}
